import { useMemo } from 'react'

import { Dropdown } from 'core-components/library/dropdown'
import {
  ISystemWidgetSettings,
  TSystemWidgetAbsolutePosition,
} from 'core-components/sitebuilder/models/flexGrid/ISystemWidgetSettings'
import { BaseCrud, Static } from 'core-components/types'

interface IAbsolutePositionSelector {
  value: TSystemWidgetAbsolutePosition | undefined
  onChange: (newData: Partial<ISystemWidgetSettings>) => void
}

export const AbsolutePositionSelector = ({ value, onChange }: IAbsolutePositionSelector) => {
  const source = useMemo(() => {
    return new BaseCrud({
      fetcher: new Static([
        { id: 'left', title: 'Left' },
        { id: 'right', title: 'Right' },
      ]),
      keyField: 'id',
    })
  }, [])

  return (
    <Dropdown
      label="Position"
      caption="title"
      source={source}
      value={value as string}
      onChange={(newValue) => {
        onChange({
          absolutePosition: newValue as TSystemWidgetAbsolutePosition,
        })
      }}
    />
  )
}
